import {CONSONANT_VOWEL_PAIRS_P_B} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_pb";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_P_B_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_P_B} title="Consonant-Vowel Pairs: ㅂ (p/b)"  />
     </>
);}